var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconChartLineUp = function SvgIconChartLineUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 3.5a1 1 0 0 1 1 1v9.586l4.293-4.293a1 1 0 0 1 1.414 0L12 12.086 17.086 7H15.75a1 1 0 1 1 0-2h3.75a1 1 0 0 1 1 1v3.75a1 1 0 1 1-2 0V8.414l-5.793 5.793a1 1 0 0 1-1.414 0L9 11.914l-5 5V18.5h17a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1"
  })));
};
export default SvgIconChartLineUp;